import React, { useEffect } from 'react';
import Modal from '@digital-hig/mui/dist/Modal';
// eslint-disable-next-line import/no-extraneous-dependencies
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import Typography from '@digital-hig/mui/dist/Typography';
import {
  isCongratsVisible,
  setCongratsVisible,
} from '../store/curatedSlice';
import { getUserDetails } from '../store/userSlice';
import { styleVariables } from '../common/constants';

const ConfettiContainer = styled.div`
  position: fixed; 
  width: 100vw; 
  height: 0;
  top: 0; 
  z-index:2010;
  
  .confetti {
    width: 10px;
    height: 10px;
    background-color: ${styleVariables.gray500};
    position: absolute;
    left: 50%;
    transform-origin: left top;
    z-index: 100;
    top: -10px;
  }

.confetti-0 {
  animation: confetti0 5.9s ease-in-out 0.2s 1;
}

 @keyframes confetti0 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,26.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,56.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,81.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-1 {
  animation: confetti1 4.7s ease-in-out 0.2s 1;
}

 @keyframes confetti1 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,28.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,56.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,78.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-2 {
  animation: confetti2 4.9s ease-in-out 0.2s 1;
}

 @keyframes confetti2 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,26.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,54.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,74.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-3 {
  animation: confetti3 4.1s ease-in-out 0.2s 1;
}

 @keyframes confetti3 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,33.33333333333333vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,55.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,74.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-4 {
  animation: confetti4 5.1s ease-in-out 0.2s 1;
}

 @keyframes confetti4 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,29.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,48.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,76.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-5 {
  animation: confetti5 5.5s ease-in-out 0.2s 1;
}

 @keyframes confetti5 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,29.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,54.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,78.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-6 {
  animation: confetti6 5.2s ease-in-out 0.2s 1;
}

 @keyframes confetti6 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,27.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,56.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,79.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-7 {
  animation: confetti7 4.1s ease-in-out 0.2s 1;
}

 @keyframes confetti7 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,24.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,54.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,72.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-8 {
  animation: confetti8 4.8s ease-in-out 0.2s 1;
}

 @keyframes confetti8 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,26.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,47.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,82.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}



.confetti-9 {
  animation: confetti9 5.8s ease-in-out 0.2s 1;
}

 @keyframes confetti9 {
    0% { transform: rotateZ(15deg) rotateY(0deg) translate(0,0); }
    25% { transform: rotateZ(5deg) rotateY(360deg) translate(-3vw,25.333333333333332vh); }
    50% { transform: rotateZ(15deg) rotateY(720deg) translate(4vw,50.5vh); }
    75% { transform: rotateZ(5deg) rotateY(1080deg) translate(-6vw,82.5vh); }
    100% { transform: rotateZ(15deg) rotateY(1440deg) translate(6vw,105vh); }
}


`;

const InnerModal = styled.div`
  overflow: hidden;
  width:300px;


  .modal-content {
 
    p {
      margin: 24px 0;
    }
    
    a {
      margin-top: 48px;
      float: right;
    }

  }
  
  @media only screen and (max-width: 800px) {
   
    width:100%;
    
    .modal-content {
      min-height: 0px;
    }
  }

`;

const CongratsModal = ({ uri }) => {
  const dispatch = useDispatch();
  const isOpen = useSelector(isCongratsVisible);
  const userData = useSelector(getUserDetails);
  const rnd = (i) => Math.floor(Math.random() * i);
  const nextStepsPath = `${uri}#nextSteps`;
  function closeModal() {
    dispatch(setCongratsVisible(false));
  }

  useEffect(() => {
    const confettiContainer = document.getElementById('confetti-container');
    const colors = ['#0696D7', '#FAA21B', '#EB5555', '#3970B9', '#32BCAD', '#87B340'];

    for (let cons = 0; cons < 800; cons += 1) {
      const confetti = document.createElement('div');
      confetti.setAttribute('class', `confetti confetti-${rnd(10)}`);
      confetti.setAttribute('style', `top: -${rnd(50) + 10}px; background-color: ${colors[rnd(6)]}; left: ${rnd(1441) / 10}%; animation-delay: ${rnd(101) / 10}s;`);
      confettiContainer.appendChild(confetti);
    }
  }, []);
  return (
    <>
      <ConfettiContainer id="confetti-container" />
      <Modal
        className="congrats-modal"
        open={isOpen}
        handleClose={closeModal}
        maxWidth="lg"
        displayLogo
        actions={false}
        content={(
          <InnerModal>
            <div className="modal-content">
              <Typography variant="headline-small">
                Congratulations,
                {' '}
                {userData?.first}
                !
              </Typography>
              <Typography variant="body-copy-medium">You&apos;ve completed all required units within this course.</Typography>

              <Button component={Link} to={nextStepsPath} onClick={closeModal}>
                <span>View Next Steps</span>
              </Button>

            </div>
          </InnerModal>
        )}
      />
    </>
  );
};

CongratsModal.propTypes = {
  uri: PropTypes.string.isRequired,
};

export default CongratsModal;
